import type { CreditUsage } from '#src/types/billing.ts';

export type UsageStatus = 'ok' | 'warn' | 'extra-credits' | 'exhausted';

export function getUsageStatus(usage: CreditUsage | null | undefined): UsageStatus {
	if (!usage || usage.planQuota === 0 || usage.softLimit) {
		return 'ok';
	}
	const percent = (usage.creditsUsedThisMonth / usage.planQuota) * 100;
	if (percent >= 100) {
		return usage.grantBalance > 0 ? 'extra-credits' : 'exhausted';
	}
	return percent > 75 ? 'warn' : 'ok';
}

export function getUsagePercent(usage: CreditUsage | null | undefined): number | null {
	if (!usage || usage.planQuota === 0) {
		return null;
	}
	return Math.min(100, (usage.creditsUsedThisMonth / usage.planQuota) * 100);
}
